/**
 * Range Field Default Configuration
 *
 * Slider/range input for selecting values within a min-max range.
 * Properties aligned with API JSON configuration structure.
 */

export interface RangeFieldConfig {
  label: string;
  showTitle: boolean;
  exclusionType: 'hide' | 'disable';
  displayName: string;
  shortDisplayName?: string;
  required: boolean;
  value: number;
  min: number;
  max: number;
  step: number;
}

export const RANGE_DEFAULT_CONFIG: Omit<RangeFieldConfig, 'label' | 'displayName'> = {
  showTitle: true,
  exclusionType: 'hide',
  shortDisplayName: '',
  required: false,
  value: 50,
  min: 0,
  max: 100,
  step: 1,
};

/**
 * Create default configuration for a range field
 * @param fieldName The field name to use as label
 */
export const createRangeConfig = (fieldName: string): RangeFieldConfig => ({
  ...RANGE_DEFAULT_CONFIG,
  label: fieldName,
  displayName: '',
});

export default createRangeConfig;
